import { Injectable, inject } from '@angular/core';
import { withLatestFrom, map } from 'rxjs';
import { HeatloadStore } from '../../state/heatload/heatload.store';
import { TranslateService } from '@ngx-translate/core';
import { WindowsAndGlazingFormValue } from '@nx-customer-apps/shared/interfaces';
import { FormName } from '@nx-customer-apps/shared/enums';
import { windowPercentageAreaToPhraseKeyDictionary, windowTypeToPhrase } from '@nx-customer-apps/shared/utils';
import { HeatloadFormOptionsService } from './heatload-form-options.service';
import { ProjectStore } from '../../state/project/project.store';
import { HeatloadPrefillMapper } from '../../services';
import { AccordionService } from '../../shared/interfaces';
import { WindowsAndGlazingFormService } from '../../shared/components/windows-and-glazing/services/windows-and-glazing-form.service';

@Injectable({
    providedIn: 'root'
})
export class WindowsAndGlazingService implements AccordionService {
    private prefillMapper = inject(HeatloadPrefillMapper);
    private heatloadStore = inject(HeatloadStore);
    private formService = inject(WindowsAndGlazingFormService);
    private heatloadFormOptionsService = inject(HeatloadFormOptionsService);
    private projectStore = inject(ProjectStore);
    private translate = inject(TranslateService);

    public questions$ = this.heatloadStore.windows$.pipe(
        withLatestFrom(this.projectStore.project$, this.heatloadStore.cache$),
        map(([windows, project, cache]) => ({
            windows,
            project,
            cache
        })),
        map(state => {
            if (!state.windows) {
                return null;
            }
            const projectPrefill = this.prefillMapper.projectToWindowsAndGlazingPrefill(state.project);
            const cachePrefill = this.prefillMapper.stateToWindowsAndGlazingPrefill(state.cache?.windowsAndGlazing);
            const typeOfGlazingOptions = state.windows.map(window => window.windowType!);
            const options = this.heatloadFormOptionsService.getWindowsAndGlazingFormOptions(
                typeOfGlazingOptions,
                cachePrefill || projectPrefill
            );
            return this.formService.getWindowsAndGlazingQuestions(options);
        })
    );

    public getSuccessMessage(formValue: WindowsAndGlazingFormValue): string {
        const windowType = this.translate.instant(windowTypeToPhrase[formValue.typeOfGlazing]);
        const percantageArea = this.translate.instant(windowPercentageAreaToPhraseKeyDictionary[formValue.windowsPercentageArea]);
        return `${percantageArea} • ${windowType}`;
    }

    public isExpanded$ = this.isSameValueSubmitedModernizationAndInsulation$();

    private isSameValueSubmitedModernizationAndInsulation$() {
        return this.heatloadStore.sameValueSubmited$.pipe(map(form => form?.formName === FormName.ModernizationsAndInsulation));
    }
}
